import React from 'react'

const HeaderSpace: React.FC = () => (
  <div className="w-full py-4 opacity-0 HeaderSpace">
    <div className="w-full h-10" />
  </div>
)

export default HeaderSpace
